import React from "react";
import "./About.css";
const About = () => {
  return (
    <div>
      <h2 className="about">
        {" "}
        Thank you for visiting our outdoor Archer camping Gears!
      </h2>
    </div>
  );
};

export default About;
